import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { ScorecardClient, scorecardApiRef } from './api/ScorecardApi';

export const scorecardPlugin = createPlugin({
  id: 'scorecard',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: scorecardApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ScorecardClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/** How well the catalog is described, mounted at /scorecards. */
export const ScorecardPage = scorecardPlugin.provide(
  createRoutableExtension({
    name: 'ScorecardPage',
    component: () =>
      import('./components/ScorecardPage').then(m => m.ScorecardPage),
    mountPoint: rootRouteRef,
  }),
);

/** One entity's score, for its overview tab. */
export const EntityScorecardCard = scorecardPlugin.provide(
  createComponentExtension({
    name: 'EntityScorecardCard',
    component: {
      lazy: () =>
        import('./components/ScorecardPage/EntityScorecardCard').then(
          m => m.EntityScorecardCard,
        ),
    },
  }),
);
